export class Script {

  constructor(
    readonly fileName: string,
    readonly script: string
  ) {
  }
}
